import React from 'react'
import { useRouter } from 'next/router'

import {
  addAccessTokenToSession,
  addOrderIdToSession,
  userHasAuthenticationParams,
} from 'utils/sessionHelper'
import { oSeriesPages } from 'types/oSeriesPages'

type Props = {
  children: React.ReactNode
}

function EnsureAuthenticated({ children }: Props): JSX.Element {
  const router = useRouter()

  if (router.query.order_id && router.query.access_token) {
    addOrderIdToSession(parseInt(router.query.order_id as string))
    addAccessTokenToSession(router.query.access_token as string)
  }

  if (!userHasAuthenticationParams()) {
    router.replace(
      `/${router.locale}/${router.query.pipe}/${oSeriesPages.landing}`
    )

    return null
  }

  return <>{children}</>
}

export default EnsureAuthenticated
